
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {Datetime} from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import {regex, formRules} from "@/utils/formRules";
import { Getter } from "vuex-class";

@Component({
    components: {
        Datetime,
    },
})
export default class GuestInvitationOptions extends Vue {
    @Prop({default: null})
    public invitation: {
      timeLimited: boolean,
      countLimited: boolean,
      notificationType: string,
      keyAccess: any,
      startDate: string,
      endDate: string,
      countAccessLeft: number,
    };

    @Prop({default: null})
    public guestGroup: any;

    @Prop({default: null})
    public newContact: any;

    @Prop({default: false})
    public edit: boolean;

    @Prop({default: false})
    public disabled: boolean;

    @Getter private isMobile: boolean;

    private wording: any = null;
    private blockMail: boolean = false;
    private blockPhone: boolean = false;

    @Watch("invitation.timeLimited")
    public handlerTimeLimited(newVal: boolean) {
        if (newVal && !this.invitation.endDate) {
            this.invitation.startDate = (new Date()).toISOString();
        } else if (!newVal) {
            this.invitation.startDate = (new Date()).toISOString();
            this.invitation.endDate = null;
        }
    }

    @Watch("invitation.countLimited")
    public handlerCountLimited(newVal: boolean) {
        this.invitation.countAccessLeft = newVal ? 1 : -1;
    }

    @Watch("invitation.startDate")
    public handlerStartDate(newVal: any) {
        if (this.invitation.endDate && newVal > this.invitation.endDate) {
            this.invitation.endDate = newVal;
        }
    }

    @Watch("guestGroup")
    public handlerNewGuest(newVal: any) {
        if (this.guestGroup && newVal) {
            this.manageSendingMethode();
        }
    }

    @Watch("newContact", {deep: true})
    public handlerNewContact(newVal: any) {
        if (this.newContact && newVal) {
            this.manageSendingMethode();
        }
    }

    private mounted(): void {
       this.manageSendingMethode();
       this.wording = {
            ok: this.$i18n.t("actions.next"),
            cancel: this.$i18n.t("actions.cancel"),
        };
    }

    private manageSendingMethode(): void {
        // check if this is already a contact and hide email/phone if he doesn't have them
        if (this.guestGroup?.Users) {
            this.blockPhone = !this.guestGroup.Users[0].phone;
            this.blockMail = !formRules.isEmail(this.guestGroup.Users[0].email);
        } else if (this.newContact) {
            // check if the contact being created has a valid phone number / email
            if (regex.validPhoneNumber.test(this.newContact.phone?.replace(/ /g, "")) ) {
                this.blockPhone = false;
                this.invitation.notificationType = "sms";
            } else {
                this.blockPhone = true;
            }
            if (formRules.isEmail(this.newContact.email)) {
                this.blockMail = false;
                this.invitation.notificationType = "email";
            } else {
                this.blockMail = true;
            }
        }
    }
}
